export enum QuestionCode {
  Connection = 'pep.question.connection',
  Relatives = 'pep.question.relatives',
  Personal = 'pep.question.ownuse',
  USIndica = 'us-indicia',
  DualCitizenship = 'dual-citizenship',
  ExpectedMonthlyDeposit = 'expected-monthly-deposit',
  GrossMonthlyIncome = 'gross-monthly-income',
  FundingSource = 'funding-source',
  MultipleFundingSources = 'multiple-funding-sources',
  RenouncedUSCitizenship = 'renounced-us-citizenship',
  AccountTypeOrder = 'account-type-order',
  EXCPrimaryAccount = 'exc-primary-account',
  TotalAnnualDeposit = 'total-annual-value',
  AccountPurpose = 'account-purpose',
  MinorConsentSign = 'minor-consent-sign',
  MinorOther = 'minor-other',
  //For remediation
  RemediationExpectedMonthlyDeposits = 'remediation-expected-monthly-deposits',
  RemediationFundingSources = 'remediation-funding-sources',
}

export type PEPQuestion = {
  id: string;
  code: string;
  question: string;
  additionalInfo?: string;
  info?: string;
  priority: number;
  description?: string;
  tooltip?: string;
  green?: boolean;
  extraProps?: Record<string, unknown>;
};

export type QuestionWithAnswer = {
  answer?: boolean;
} & PEPQuestion;

export type PEPAnswer = {
  questionId: string;
  positive: boolean;
  position?: string;
  countryCode?: string;
  meWorking?: boolean;
  startDate?: string;
  endDate?: string;
  fullName?: string;
  isPersonWorking?: boolean;
  relationship?: string;
  green?: boolean;
  code?: QuestionCode;
  question?: string;
};

export enum PEPAnswerStatus {
  NotAnswered = 'NOT_ANSWERED',
  InReview = 'IN_REVIEW',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
}
